import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import RichTextEditor from '../../../common/RichTextEditor';
import { useCV } from '../contexts/CVContext';

const ProfessionalSummary = () => {
  const { isDataReady, cvData, updateProfessionalSummary, readonly } = useCV();
  const [summary, setSummary] = useState('');
  
  // Initialize from context only once
  useEffect(() => {
    if (isDataReady && cvData.professionalSummary) {
      setSummary(cvData.professionalSummary);
    }
  }, [isDataReady, cvData.professionalSummary]);
  
  const handleChange = (content) => {
    setSummary(content);
    updateProfessionalSummary(content);
  };
  
  return (
    <Box>
      <RichTextEditor 
        readonly={readonly}
        initialContent={cvData.professionalSummary || ''}
        description="Use the editor to write your professional summary. You can use the editor to format your text."
        footer="Tip: write 400-600 characters to increase our chances"
        onChange={handleChange}
      />
    </Box>
  );
};

export default ProfessionalSummary; 